<template>
  <div
    id="footerBar"
    class="footerBar"
    :class="{'is-login':login,'shadow':$route.name=='Download',fixed:fixed}"
  >
    <ul class="link">
      <router-link v-if="!teacher" tag="li" title="关于我们" :to="{ name: 'About' }">
        <span>关于我们</span>
      </router-link>
      <router-link v-if="!teacher" tag="li" title="联系我们" :to="{ name: 'ContactUs' }">
        <span>联系我们</span>
      </router-link>
      <router-link v-if="!teacher" tag="li" title="帮助中心" :to="{ name: 'HelpCenter' }">
        <span>帮助中心</span>
      </router-link>
      <a href="/teacher" target="_blank" v-if="!teacher">
        <span>讲师登录</span>
      </a>
      <a href="/assist" target="_blank" v-if="!teacher">
        <span>助教登录</span>
      </a>
    </ul>
    <p class="copyright">
      <span>客服电话：{{$store.state.webConfig.contact}}</span>
      <span>{{$store.state.webConfig.copyright}}</span>
      <a
        :href="$store.state.webConfig.record_no_link"
        target="_blank"
      >{{$store.state.webConfig.record_no}}</a>

      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=53011402000613" target="_blank">

        <img
          src="@/assets/images/gongan.png"
          style="vertical-align: middle; margin-right: 2px; margin-left:10px;"
        />
        公安备案号：53011402000613
      </a>
    </p>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    login: {
      default: false
    },
    teacher: {
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss" scoped>
.footerBar {
  padding: 44px 0 42px 0;
  background: #595959;
  box-sizing: border-box;
  &.shadow {
    box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.05);
  }
  &.fixed {
    position: fixed;
    bottom: 0;
    width: 100%;
  }
}

.footerBar .link {
  text-align: center;
}

.footerBar .link li,
.footerBar .link a {
  margin-right: 68px;
  cursor: pointer;
  display: inline-block;
  height: 15px;
  font-size: 15px;
  color: white;
  line-height: 1;
  &:last-child {
    margin-right: 0;
  }
}

.footerBar .link li.phone {
  border: none;
}

.footerBar .link li span,
.footerBar .link li a {
  display: block;
}

.footerBar .copyright {
  margin: 24px auto 0 auto;
  text-align: center;
  height: 16px;
  font-size: 15px;
  color: white;
  line-height: 16px;
  opacity: 0.5;
  a {
    color: white;
  }
  span {
    margin-right: 18px;
  }
}
</style>
